import { asyncToGenerator as _asyncToGenerator, regenerator as _regenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { fetchXhr } from '../../fetchXhr.js';
import { buildCommonFetchOptions } from './buildCommonFetchOptions.js';
var externalS3MediaUploader = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee(files, basePath, parameters, onProgress, authToken
  // TODO: refactor this function to take an object instead of 5 arguments
  // eslint-disable-next-line max-params
  ) {
    var _file, response, data, _fields, postUrl;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (!(files.length > 0 || files)) {
            _context.n = 4;
            break;
          }
          _file = files.length > 0 ? files[0] : files;
          _context.n = 1;
          return fetch("".concat(basePath, "/media"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              Authorization: "Bearer ".concat(authToken)
            },
            body: JSON.stringify({
              data: {
                type: 'media',
                attributes: Object.assign({
                  name: _file.name.replace(/[^A-Za-z0-9_.-]/g, '-')
                }, parameters)
              }
            }),
            credentials: 'same-origin'
          });
        case 1:
          response = _context.v;
          _context.n = 2;
          return response.json();
        case 2:
          data = _context.v;
          _fields = data.data.attributes.s3_post_fields;
          postUrl = data.data.attributes.s3_post_url;
          _context.n = 3;
          return s3Uploader(_file, _fields, postUrl, onProgress);
        case 3:
          return _context.a(2, data);
        case 4:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function externalS3MediaUploader(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
var s3MediaUploader = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee2(files, baseUrl, parameters, onProgress, authToken) {
    var url, file, response, data, fields, postUrl;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          if (!(files.length <= 0 && !files)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, null);
        case 1:
          url = baseUrl || '/api/data';
          file = files.length > 0 ? files[0] : files;
          _context2.n = 2;
          return fetch("".concat(url, "/media"), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/vnd.api+json',
              Authorization: "Bearer ".concat(authToken)
            },
            body: JSON.stringify({
              data: {
                type: 'media',
                attributes: Object.assign({
                  name: file.name.replace(/[^A-Za-z0-9_.-]/g, '-')
                }, parameters)
              }
            }),
            credentials: 'same-origin'
          });
        case 2:
          response = _context2.v;
          _context2.n = 3;
          return response.json();
        case 3:
          data = _context2.v;
          fields = data.data.attributes.s3_post_fields;
          postUrl = data.data.attributes.s3_post_url;
          _context2.n = 4;
          return s3Uploader(file, fields, postUrl, onProgress);
        case 4:
          return _context2.a(2, data);
      }
    }, _callee2);
  }));
  return function s3MediaUploader(_x6, _x7, _x8, _x9, _x0) {
    return _ref2.apply(this, arguments);
  };
}();
// fields url is offline content create call
var s3Uploader = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator().m(function _callee3(file, fields, url, onProgress) {
    var formData, keysToFix;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          formData = new FormData();
          keysToFix = ['x_amz_signature', 'x_amz_date', 'x_amz_algorithm', 'x_amz_credential'];
          Object.keys(fields).forEach(function (key) {
            if (keysToFix.includes(key)) {
              formData.append(key.split('_').join('-'), fields[key]);
            } else {
              formData.append(key, fields[key]);
            }
          });
          formData.append('file', file);
          _context3.n = 1;
          return fetchXhr(url, buildCommonFetchOptions(formData, onProgress));
        case 1:
          return _context3.a(2, _context3.v);
      }
    }, _callee3);
  }));
  return function s3Uploader(_x1, _x10, _x11, _x12) {
    return _ref3.apply(this, arguments);
  };
}();
export { externalS3MediaUploader, s3MediaUploader, s3Uploader };